
import { useSelector } from 'react-redux';
import { IState } from '../store/interfaces/state';
import FlippableCard from './FlippableCard';

const AboutPage = (props: any) => {

    const descriptions = [
      {
          'title': '💰  $20,000 in Prizes'
          , 'img': 'Dashboard'
          , 'desc': [
              "The top 30 analysts win prizes each week"
              , "The top analyst will earn ~$2k over the course of the tournament"
          ]
      }
      , {
          'title': '📈  Boost your Profile'
          , 'img': 'Insights'
          , 'desc': [
              "Competing in the FPL is a great way to amplify your research"
            //   , "Top performers have a path to becoming a Flipside Ambassador"
            //   , "Top performers get noticed by the Flipside community and have an established path to becoming Flipside Ambassadors"
              , "Top performers have an established path to becoming Flipside Ambassadors"
          ]
      }
      , {
          'title': '📅  Begins August 28th'
          , 'img': 'Protocol'
          , 'desc': [
              'Get your dashboards ready and your threads set to fire; the Play-In begins on August 28th!'
              , "Top analysts from the play-in qualify for the Flipside Premier League"
          ]
      }
  ]
  const descriptionDivs = descriptions.map(x => {
      const d = x.desc.map(
          y => <div style={{'paddingTop': '15px'}}><span dangerouslySetInnerHTML={{ __html: y }} ></span></div>
      )
      const img = require(`../assets/icons/${x.img}.png`);
      return(
          <div className='col-lg-4'>
              <div className='prize-descriptions-col'>
                  {/* <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="77" height="82" viewBox="0 0 77 82" fill="none" id="1199882405" className="svg u_1199882405" data-icon-custom="true" data-icon-name="icon.svg"> <path d="M9.97279 67.3757L9.96871 67.3734C9.00993 66.8377 8.30368 66.4383 7.49143 65.8361L7.05661 66.4226L7.49141 65.8361C5.95018 64.6935 4.68302 63.3969 3.59997 61.7887L2.99442 62.1964L3.59997 61.7886C1.87091 59.221 0.730062 56.1677 0.730062 52.7584L0.730069 30.9895V28.8498C0.730069 25.1856 2.26364 21.1565 4.49714 18.6168C6.8112 15.9857 8.04494 15.2946 10.4112 13.9691C11.0722 13.5988 11.8215 13.179 12.7074 12.6537L25.9126 5.15544C26.5029 4.83278 27.089 4.49278 27.6791 4.15052C30.5804 2.46766 33.5761 0.730062 37.6162 0.730062C40.8055 0.730062 42.7939 1.10676 44.6354 1.8295C46.0682 2.39182 47.414 3.1606 49.1876 4.1737C49.749 4.4944 50.3533 4.83959 51.0168 5.21046C51.9298 5.72081 52.7492 6.18563 53.6267 6.71316L54.0029 6.08746L53.6267 6.71317C55.3411 7.74379 57.1453 8.73654 58.9348 9.72125L58.9414 9.72488C60.7378 10.7133 62.5193 11.6938 64.2077 12.7088C65.1049 13.2481 65.9401 13.7219 66.8576 14.2347L67.2138 13.5974L66.8577 14.2347C67.8164 14.7705 68.5227 15.1698 69.3349 15.772L69.7698 15.1856L69.335 15.772C71.5906 17.4444 73.5763 19.7558 74.6517 22.3422C75.4663 24.3016 76.0963 26.2306 76.0963 28.8498V52.7584C76.0963 56.2902 74.9311 59.2757 73.1638 61.8822C72.8942 62.2799 72.6193 62.6614 72.3292 62.9913C70.0152 65.6225 68.7814 66.3136 66.4152 67.6391C65.7543 68.0093 65.005 68.429 64.1192 68.9543L50.919 76.4498C50.9172 76.4508 50.9154 76.4518 50.9136 76.4528C49.9953 76.9547 49.2073 77.4103 48.494 77.8228C47.1266 78.6136 46.0336 79.2456 44.8224 79.7408C43.0414 80.4689 41.0298 80.878 37.6162 80.878C34.7985 80.878 31.8797 79.7454 28.9549 78.2094C27.4988 77.4447 26.0626 76.5919 24.6512 75.7482C24.5657 75.6971 24.4804 75.6461 24.3951 75.5951C23.0811 74.8092 21.7859 74.0345 20.5416 73.3706L9.97279 67.3757Z" fill="black" fill-opacity="0.89" stroke="url(#pattern0)" stroke-width="1.46012"></path><defs> <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1"> <use xlinkHref="#image0_911_45473" transform="matrix(0.00347438 0 0 0.00504739 -4.63803 -1.85418)"></use></pattern></defs>  */}
                  {/* </svg> */}
                  {/* <img src={String(img)} /> */}
                  <div className='descriptions-row-header'>{x.title}</div>
                  <div className='prize-descriptions-row-text'>{d}</div>
              </div>
          </div>
      )
  })
	return (
        <div className='about-page'>
            <div className='about-header'>
                A Dashboarding Tournament
            </div>
            <div className='row about-description'>
                <div className='col-12'>
                    <ul>
                        <li>Dashboards are scored based on time spent in the top 40 of the <a target='_blank' href='https://flipsidecrypto.xyz/discover'>trending dashboard</a> page</li>
                        <li>The score of your top 2 dashboards count for your overall score each week</li>
                        <li>The Play-In starts Monday, August 28th at 4pm UTC and lasts 7 days</li>
                        <li>The top 28 analysts then qualify for the Flipside Premier League</li>
                        <li>Check the <span style={{'fontStyle': 'italic'}}>#premier-league</span> channel in the <a target='_blank' href='https://discord.com/invite/ZmU3jQuu6W'>flipside discord</a> to learn more</li>
                    </ul>
                </div>
            </div>
            <div className='prize-descriptions-outer' style={{'paddingTop': '30px'}}>
                {/* <div className='prize-descriptions' style={{'paddingTop': '30px'}}> */}
                    {/* <div className='prize-descriptions-header'>FPL Prizes</div> */}
                    {/* <div className='prize-descriptions-info'>Prizes</div> */}
                    <div className='row prize-descriptions-row'>
                        {
                            descriptionDivs
                        }
                    </div>
                {/* </div> */}
            </div>
        </div>
	);
}

export default AboutPage;